import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SignatureSettings from "../components/settings/SignatureSettings";
// import ProfileSettings from "../components/settings/ProfileSettings";
import ThemeSettings from "../components/settings/ThemeSettings";
import StorageSettings from "../components/settings/StorageSettings";
import { AUTH_STORAGE_KEY, SERVER_URL } from "../socket";
import { loadLabels, createLabel, deleteLabel } from "../api/labelsApi";
import ChatSettings from "../components/settings/ChatSettings";
import AppLockSettings from "../components/settings/AppLockSettings";  // ✅ NEW

function SettingsPage({ signatureState, profileState, onSignOut }) {
  const [activeCategory, setActiveCategory] = useState("signatures");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const focus = params.get("focus");
    if (focus === "lock" || focus === "app-lock") {
      setActiveCategory("app-lock");
    }
  }, [location.search]);
 
  const {
    signatureList,
    defaultSignatureId,
    loading: signatureLoading,
    message: signatureMessage,
    messageType: signatureMessageType,
    refresh: refreshSignatures,
    addSignature,
    saveSignature,
    removeSignature,
    makeDefault,
    editable: signatureEditable,
  } = signatureState;

  const {
    profileForm,
    profileMessage,
    profileMessageType,
    profileSaving,
    profileUploading,
    profileImagePreview,
    ensureProfileLoaded,
    handleProfileInputChange,
    handleProfileSubmit,
    handleProfileImageSelect,
    handleProfileImageRemove,
    changePasswordForm,
    changePasswordMsg,
    changePasswordLoading,
    handleChangePasswordInput,
    handleChangePasswordSubmit,
  } = profileState;
const [showDetail, setShowDetail] = useState(false);

  useEffect(() => {
    refreshSignatures?.();
  }, [refreshSignatures]);

  useEffect(() => {
    if (activeCategory === "profile") {
      ensureProfileLoaded?.();
    }
  }, [activeCategory, ensureProfileLoaded]);

  const settingsCategories = [
    //   {
    //   id: "accounts",
    //   title: "Accounts",
    //   icon: "fa-user-circle",
    //   description: "Profile, 2FA, Send As Aliases",
    //   items: ["Profile", "2FA", "Send As Aliases"],
    // },
     {
      id: "signatures",
      title: "Signatures",
      icon: "fa-signature",
      description: "Signatures",
      items: ["Alerts", "Summaries", "Push Notification"],
    },
      {
      id: "layers",
      title: "Layers",
      icon: "fa-tag",
      description: "Create Label, Priority Tag, Auto Tagging",
      items: ["Create Label", "Priority Tag", "Auto Tagging"],
    },
    {
      id: "ui",
      title: "UI Theme",
      icon: "fa-palette",
      description: "Theme, Dark Mode, Custom Branding",
      items: ["Theme", "Dark Mode", "Custom Branding"],
    },
     {
      id: "storage",
      title: "Storage",
      icon: "fa-database",
      description: "Storage Usage, Backup Settings",
      items: ["Storage Usage", "Backup Settings"],
    },
    {
      id: "app-lock",
      title: "App Lock",
      icon: "fa-lock",
      description: "Protect the app with PIN or pattern lock",
      items: ["PIN", "Pattern", "Status"],
    },
    {
      id: "security",
      title: "Security",
      icon: "fa-shield-alt",
      description: "2FA, IP Restriction, Audit Logs",
      items: ["2FA", "IP Restriction", "Audit Logs"],
    },
      {
      id: "chat",
      title: "Chat",
      icon: "fa-comment-dots",
      description: "Quick Replies, Chat History, Backup",
      items: ["Quick Replies", "Chat History", "Backup"],
      },
    {
      id: "general",
      title: "General",
      icon: "fa-cog",
      description: "Language, Time Zone, Date Format",
      items: ["Language", "Time Zone", "Date Format"],
    },
    {
      id: "mailbox",
      title: "Mailbox",
      icon: "fa-envelope",
      description: "Inbox, Spam, Archived, Custom Folders",
      items: ["Inbox", "Spam", "Archived", "Custom Folders"],
    },
   
    {
      id: "layout",
      title: "Inbox Layout",
      icon: "fa-th",
      description: "Default View, Priority Inbox, Filter by Status",
      items: ["Default View", "Priority Inbox", "Filter by Status"],
    },
  
    {
      id: "filters",
      title: "Filters",
      icon: "fa-filter",
      description: "Create Rule, Auto Forward, SLA Routing",
      items: ["Create Rule", "Auto Forward", "SLA Routing"],
    },
    {
      id: "integrations",
      title: "Integrations",
      icon: "fa-puzzle-piece",
      description: "CRM, Ticket System, Calendar",
      items: ["CRM", "Ticket System", "Calendar"],
    },
    
  ];

  return (
    <section className="admin-users">
      <div className="settings-header">
         <button
      className="mobile-back-btn"
      onClick={() => setShowDetail(false)}
      style={{ display: "none" }} // shown via CSS on mobile
    >
      ← Back
    </button>
        <h1>
          <i className="fa-solid fa-cog"></i> Settings
        </h1>
      </div>
 
      <div className="settings-layout">
        {/* Left: Categories Grid */}
          <div className={`settings-categories-section ${showDetail ? "hidden-mobile" : ""}`}>

          <div className="settings-categories-grid">
            {settingsCategories.map((category) => (
              <div
                key={category.id}
                className={`settings-category-card ${
                  activeCategory === category.id ? "active" : ""
                }`}
              onClick={() => {
  setActiveCategory(category.id);
  setShowDetail(true); // show detail panel on mobile
}}
              >
                <div className="category-icon">
                  <i className={`fa-solid ${category.icon}`}></i>
                </div>
                <div className="category-content">
                  <h3 className="category-title">{category.title}</h3>
                  <p className="category-description">{category.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: Details Panel */}
        <div className="settings-details-section">
          {activeCategory === "general" && (
            <GeneralSettings />
          )}
          {/* {activeCategory === "profile" && (
            <ProfileSettings
              profileForm={profileForm}
              profileMessage={profileMessage}
              profileMessageType={profileMessageType}
              profileSaving={profileSaving}
              profileUploading={profileUploading}
              profileImagePreview={profileImagePreview}
              onInputChange={handleProfileInputChange}
              onSubmit={handleProfileSubmit}
              onImageSelect={handleProfileImageSelect}
              onImageRemove={handleProfileImageRemove}
              changePasswordForm={changePasswordForm}
              changePasswordMsg={changePasswordMsg}
              changePasswordLoading={changePasswordLoading}
              onChangePasswordInput={handleChangePasswordInput}
              onChangePasswordSubmit={handleChangePasswordSubmit}
              onSignOut={onSignOut}
            />
          )} */}
          {/* {activeCategory === "accounts" && (
            <ProfileSettings
              profileForm={profileForm}
              profileMessage={profileMessage}
              profileMessageType={profileMessageType}
              profileSaving={profileSaving}
              profileUploading={profileUploading}
              profileImagePreview={profileImagePreview}
              onInputChange={handleProfileInputChange}
              onSubmit={handleProfileSubmit}
              onImageSelect={handleProfileImageSelect}
              onImageRemove={handleProfileImageRemove}
              changePasswordForm={changePasswordForm}
              changePasswordMsg={changePasswordMsg}
              changePasswordLoading={changePasswordLoading}
              onChangePasswordInput={handleChangePasswordInput}
              onChangePasswordSubmit={handleChangePasswordSubmit}
              onSignOut={onSignOut}
            />
          )} */}
          {activeCategory === "ui" && <ThemeSettings />}
           {activeCategory === "storage" && <StorageSettings />}
          {activeCategory === "signatures" && (
            <SignatureSettings
              signatureList={signatureList}
              defaultSignatureId={defaultSignatureId}
              loading={signatureLoading}
              message={signatureMessage}
              messageType={signatureMessageType}
              onSaveSignature={saveSignature}
              onDeleteSignature={removeSignature}
              onSetDefault={makeDefault}
              onCreateSignature={addSignature}
              editable={signatureEditable}
            />
          )}
          {activeCategory === "layers" && (
            <LayersSettings />
          )}
        {activeCategory === "chat" && <ChatSettings />}

          {activeCategory === "layout" && (
            <LayoutSettings />
          )}

          {activeCategory === "app-lock" && <AppLockSettings />}
          {activeCategory === "security" && (
            <SecuritySettings
              changePasswordForm={changePasswordForm}
              changePasswordMsg={changePasswordMsg}
              changePasswordLoading={changePasswordLoading}
              onChangePasswordInput={handleChangePasswordInput}
              onChangePasswordSubmit={handleChangePasswordSubmit}
            />
          )}

          {(activeCategory === "filters" ||
            activeCategory === "integrations" ||
            activeCategory === "mailbox") && (
            <div className="settings-placeholder">
              <p>
                <i className="fa-solid fa-cog" style={{ marginRight: "8px" }}></i>
                {settingsCategories.find((c) => c.id === activeCategory)?.title} settings coming soon
              </p>
            </div>
          )}
        </div>
       
      </div>
    </section>
  );
}

// Placeholder General Settings Component
function GeneralSettings() {
  return (
    <div className="settings-details-panel">
      <div className="settings-panel-header">
        <h2>
          <i className="fa-solid fa-cog"></i> General
        </h2>
      </div>
      <div className="settings-form">
        <div className="settings-form-group">
          <label>Language</label>
          <select defaultValue="en-US">
            <option value="en-US">English (US)</option>
            <option value="en-GB">English (UK)</option>
            <option value="es">Español</option>
            <option value="fr">Français</option>
            <option value="de">Deutsch</option>
            <option value="hi">हिन्दी</option>
          </select>
        </div>

        <div className="settings-form-group">
          <label>Time Zone</label>
          <select defaultValue="GMT+05:30">
            <option value="GMT+05:30">(GMT+05:30) India Standard Time</option>
            <option value="GMT">GMT</option>
            <option value="GMT-05:00">EST (UTC-05:00)</option>
            <option value="GMT-08:00">PST (UTC-08:00)</option>
          </select>
        </div>

        <div className="settings-form-group">
          <label>Date Format</label>
          <div className="form-radio-group">
            <label>
              <input type="radio" name="dateFormat" value="MM/DD/YYYY" defaultChecked /> MM/DD/YYYY
            </label>
            <label>
              <input type="radio" name="dateFormat" value="DD/MM/YYYY" /> DD/MM/YYYY
            </label>
            <label>
              <input type="radio" name="dateFormat" value="YYYY-MM-DD" /> YYYY-MM-DD
            </label>
          </div>
        </div>

        <button className="btn-save">Save Changes</button>
      </div>
      
    </div>
  );
}

// Layers (Labels) Settings
function LayersSettings() {
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [message, setMessage] = useState(null);

  const getAuthHeaders = () => {
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      return parsed?.token ? { Authorization: `Bearer ${parsed.token}` } : null;
    } catch (e) {
      return null;
    }
  };

  const load = async () => {
    setLoading(true);
    try {
      const res = await loadLabels(getAuthHeaders());
      setLabels(Array.isArray(res?.labels) ? res.labels : []);
    } catch (e) {
      setLabels([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
    const handler = () => load();
    window.addEventListener("labels-updated", handler);
    return () => window.removeEventListener("labels-updated", handler);
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name || !name.trim()) return setMessage({ type: "error", text: "Name is required" });
    setLoading(true);
    try {
      await createLabel({ name: name.trim() }, getAuthHeaders());
      setName("");
      setMessage({ type: "success", text: "Layer added" });
      await load();
      window.dispatchEvent(new CustomEvent("labels-updated"));
    } catch (err) {
      setMessage({ type: "error", text: "Failed to add layer" });
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this layer?")) return;
    setLoading(true);
    try {
      await deleteLabel(id, getAuthHeaders());
      setMessage({ type: "success", text: "Layer deleted" });
      await load();
      window.dispatchEvent(new CustomEvent("labels-updated"));
    } catch (err) {
      setMessage({ type: "error", text: "Failed to delete layer" });
    }
    setLoading(false);
  };

  return (
    <div className="settings-details-panel">
      <div className="settings-panel-header">
        <h2>
          <i className="fa-solid fa-layer-group"></i> Layers
        </h2>
      </div>

      <form className="settings-form" onSubmit={handleCreate}>
        {message && (
          <div className={`mail-settings-message ${message.type === "error" ? "error" : "success"}`}>{message.text}</div>
        )}

        <div className="settings-form-group">
          <label>New Layer Name</label>
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Marketing" />
        </div>

        <div>
          <button className="btn-save" type="submit" disabled={loading}>Add Layer</button>
        </div>
      </form>

      <div className="settings-form">
        <h3>All Layers</h3>
        {loading ? (
          <p>Loading...</p>
        ) : labels.length === 0 ? (
          <p className="settings-placeholder">No layers yet.</p>
        ) : (
          <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: 8 }}>
            {labels.map((l) => (
              <li key={l.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "8px 12px", border: "1px solid #e6eefc", borderRadius: 8 }}>
                <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                  <div style={{ width: 10, height: 10, borderRadius: 4, background: l.color || "#cbd5e1" }} />
                  <div>{l.name}</div>
                </div>
                <div>
                  <button className="mail-action-small" onClick={() => handleDelete(l.id)}>
                    <i className="fa-solid fa-trash"></i>
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

// Inbox Layout Settings
function LayoutSettings() {
  const [form, setForm] = useState({
    conversationView: true,
    priorityInbox: false,
    filterByStatus: "all",
    department: "",
    density: "default",
  });
  const [message, setMessage] = useState(null);

  const getAuthHeaders = () => {
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      return parsed?.token ? { Authorization: `Bearer ${parsed.token}` } : null;
    } catch (e) {
      return null;
    }
  };

  useEffect(() => {
    const load = async () => {
      try {
        const headers = getAuthHeaders();
        if (!headers) return;
        const res = await fetch(`${SERVER_URL}/api/settings/layout`, { headers });
        if (!res.ok) return;
        const data = await res.json();
        if (data?.settings) setForm(data.settings);
      } catch (e) {}
    };
    load();
  }, []);

  const handleChange = (key, value) => setForm((s) => ({ ...s, [key]: value }));

  const handleSave = async (e) => {
    e?.preventDefault();
    try {
      const headers = getAuthHeaders();
      if (!headers) return setMessage({ type: "error", text: "Not authenticated" });
      const res = await fetch(`${SERVER_URL}/api/settings/layout`, {
        method: "PUT",
        headers: { ...headers, "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("save failed");
      setMessage({ type: "success", text: "Inbox layout saved" });
      setTimeout(() => setMessage(null), 2500);
    } catch (err) {
      setMessage({ type: "error", text: "Failed to save settings" });
    }
  };

  return (
    <div className="settings-details-panel">
      <div className="settings-panel-header">
        <h2>
          <i className="fa-solid fa-th"></i> Inbox Layout
        </h2>
      </div>

      <form className="settings-form" onSubmit={handleSave}>
        {message && (
          <div className={`mail-settings-message ${message.type === "error" ? "error" : "success"}`}>{message.text}</div>
        )}

        <div className="settings-form-group">
          <label>Default View</label>
          <div className="form-radio-group">
            <label>
              <input type="radio" name="conversationView" checked={form.conversationView === true} onChange={() => handleChange("conversationView", true)} /> Conversation View
            </label>
            <label>
              <input type="radio" name="conversationView" checked={form.conversationView === false} onChange={() => handleChange("conversationView", false)} /> Message List
            </label>
          </div>
        </div>

        <div className="settings-form-group">
          <label>
            <input type="checkbox" checked={form.priorityInbox} onChange={(e) => handleChange("priorityInbox", e.target.checked)} /> Enable Priority Inbox
          </label>
        </div>

        <div className="settings-form-group">
          <label>Filter By Status</label>
          <select value={form.filterByStatus} onChange={(e) => handleChange("filterByStatus", e.target.value)}>
            <option value="all">All</option>
            <option value="unread">Unread</option>
            <option value="starred">Starred</option>
            <option value="important">Important</option>
          </select>
        </div>

        <div className="settings-form-group">
          <label>Department (optional)</label>
          <input value={form.department} onChange={(e) => handleChange("department", e.target.value)} placeholder="e.g. Support" />
        </div>

        <div className="settings-form-group">
          <label>Display Density</label>
          <div className="form-radio-group">
            <label>
              <input type="radio" name="density" checked={form.density === "default"} onChange={() => handleChange("density", "default")} /> Default
            </label>
            <label>
              <input type="radio" name="density" checked={form.density === "comfortable"} onChange={() => handleChange("density", "comfortable")} /> Comfortable
            </label>
            <label>
              <input type="radio" name="density" checked={form.density === "compact"} onChange={() => handleChange("density", "compact")} /> Compact
            </label>
          </div>
        </div>

        <div>
          <button className="btn-save" type="submit">Save Layout Settings</button>
        </div>
      </form>
    </div>
  );
}

// Security Settings with tabs
function SecuritySettings({
  changePasswordForm,
  changePasswordMsg,
  changePasswordLoading,
  onChangePasswordInput,
  onChangePasswordSubmit,
}) {
   const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const [recoveryEmail, setRecoveryEmail] = useState("");
  const [originalEmail,  setOriginalEmail]  = useState("");
  const [showOnline,     setShowOnline]     = useState(true);   // default: visible
  const [downloadMode,   setDownloadMode]   = useState("manual"); // default: manual
  const [loading,        setLoading]        = useState(false);
  const [message,        setMessage]        = useState(null);

  const getAuthHeaders = () => {
    try {
      const raw    = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      return parsed?.token ? { Authorization: `Bearer ${parsed.token}` } : null;
    } catch (e) { return null; }
  };

  // ── Load all three settings on mount ───────────────────────────────────────
  useEffect(() => {
    const load = async () => {
      const headers = getAuthHeaders();
      if (!headers) return;

      // Recovery email
      try {
        const res  = await fetch(`${SERVER_URL}/api/settings/recovery-email`, { headers });
        const data = await res.json();
        const val  = data?.recoveryEmail || "";
        setRecoveryEmail(val);
        setOriginalEmail(val);
      } catch (_) {}

      // Privacy settings (online visibility + download mode)
      try {
        const res  = await fetch(`${SERVER_URL}/api/settings/privacy`, { headers });
        const data = await res.json();
        if (data?.settings) {
          if (typeof data.settings.showOnline === "boolean") {
            setShowOnline(data.settings.showOnline);
          }
          if (data.settings.downloadMode) {
            setDownloadMode(data.settings.downloadMode);
          }
        }
      } catch (_) {}
    };
    load();
  }, []);

  // ── Save recovery email ─────────────────────────────────────────────────────
  const handleSaveEmail = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setMessage(null);
    try {
      const headers = getAuthHeaders();
      if (!headers) { setMessage({ type: "error", text: "Not authenticated" }); return; }
      const res  = await fetch(`${SERVER_URL}/api/settings/recovery-email`, {
        method:  "PUT",
        headers: { ...headers, "Content-Type": "application/json" },
        body:    JSON.stringify({ recoveryEmail }),
      });
      const data = await res.json();
      if (!res.ok) {
        setMessage({ type: "error", text: data?.error || "Failed to save" });
      } else {
        setOriginalEmail(data.recoveryEmail || recoveryEmail);
        setMessage({ type: "success", text: "Recovery email saved" });
        setTimeout(() => setMessage(null), 2500);
      }
    } catch { setMessage({ type: "error", text: "Failed to save recovery email" }); }
    finally   { setLoading(false); }
  };

  // ── Save privacy settings (online visibility + download mode) ───────────────
  const savePrivacy = async (patch) => {
    const headers = getAuthHeaders();
    if (!headers) return;
    const current = { showOnline, downloadMode };
    const updated = { ...current, ...patch };
    try {
      await fetch(`${SERVER_URL}/api/settings/privacy`, {
        method:  "PUT",
        headers: { ...headers, "Content-Type": "application/json" },
        body:    JSON.stringify(updated),
      });
    } catch (e) { console.error("Failed to save privacy setting", e); }
  };

  const handleToggleOnline = async (val) => {
    setShowOnline(val);
    await savePrivacy({ showOnline: val });
    setMessage({ type: "success", text: val ? "You will appear online to others" : "You will appear offline to others" });
    setTimeout(() => setMessage(null), 2000);
  };

  const handleDownloadMode = async (val) => {
    setDownloadMode(val);
    await savePrivacy({ downloadMode: val });
    setMessage({ type: "success", text: val === "auto" ? "Media will download automatically" : "Media will download only when tapped" });
    setTimeout(() => setMessage(null), 2000);
  };

  // ── UI ───────────────────────────────────────────────────────────────────────
  return (
    <div className="settings-details-panel">
      <div className="settings-panel-header">
        <h2>
          <i className="fa-solid fa-shield-alt"></i> Security &amp; Privacy
        </h2>
      </div>

      {message && (
        <div className={`mail-settings-message ${message.type === "error" ? "error" : "success"}`}>
          {message.text}
        </div>
      )}

      {/* ── Change password ───────────────────────────────────────────────── */}
      <form className="settings-form" onSubmit={(e) => { e.preventDefault(); onChangePasswordSubmit?.(); }} style={{ marginBottom: 18 }}>
        <div className="settings-form-group">
          <label style={{ fontWeight: 600, marginBottom: 4, display: "block" }}>Change password</label>
          <p style={{ color: "#64748b", fontSize: 13, marginBottom: 12 }}>
            Update your current password from this security panel.
          </p>

          <label style={{ display: "block", marginBottom: 8 }}>
  <span style={{ display: "block", marginBottom: 6 }}>Current password</span>

  <div style={{ position: "relative" }}>
    <input
      type={showPassword.current ? "text" : "password"}
      name="currentPassword"
      value={changePasswordForm?.currentPassword || ""}
      onChange={onChangePasswordInput}
      disabled={changePasswordLoading}
      autoComplete="current-password"
    />

    <button
      type="button"
      onClick={() =>
        setShowPassword((prev) => ({
          ...prev,
          current: !prev.current,
        }))
      }
      style={{
        position: "absolute",
        right: 10,
        top: "50%",
        transform: "translateY(-50%)",
        border: "none",
        background: "transparent",
        cursor: "pointer",
      }}
    >
      {showPassword.current ? "🙈" : "👁️"}
    </button>
  </div>
</label>

  <label style={{ display: "block", marginBottom: 8 }}>
  <span style={{ display: "block", marginBottom: 6 }}>New password</span>

  <div style={{ position: "relative" }}>
    <input
     type={showPassword.new ? "text" : "password"}
  name="newPassword"
  value={changePasswordForm?.newPassword || ""}
  onChange={onChangePasswordInput}
  disabled={changePasswordLoading}
  autoComplete="new-password"
    />

    <button
      type="button"
      onClick={() =>
        setShowPassword((prev) => ({
          ...prev,
          new: !prev.new,
        }))
      }
      style={{
        position: "absolute",
        right: 10,
        top: "50%",
        transform: "translateY(-50%)",
        border: "none",
        background: "transparent",
        cursor: "pointer",
      }}
    >
      {showPassword.new ? "🙈" : "👁️"}
    </button>
  </div>
</label>
       <label style={{ display: "block", marginBottom: 8 }}>
  <span style={{ display: "block", marginBottom: 6 }}>Confirm new password</span>

  <div style={{ position: "relative" }}>
    <input
    type={showPassword.confirm ? "text" : "password"}
  name="confirmPassword"
  value={changePasswordForm?.confirmPassword || ""}
  onChange={onChangePasswordInput}
  disabled={changePasswordLoading}
  autoComplete="new-password"
    />

    <button
      type="button"
      onClick={() =>
        setShowPassword((prev) => ({
          ...prev,
          confirm: !prev.confirm,
        }))
      }
      style={{
        position: "absolute",
        right: 10,
        top: "50%",
        transform: "translateY(-50%)",
        border: "none",
        background: "transparent",
        cursor: "pointer",
      }}
    >
      {showPassword.confirm ? "🙈" : "👁️"}
    </button>
  </div>
</label>

        </div>

        {changePasswordMsg && <div className="mail-settings-message error">{changePasswordMsg}</div>}

        <div style={{ display: "flex", gap: 10 }}>
          <button className="btn-save" type="submit" disabled={changePasswordLoading}>
            {changePasswordLoading ? "Updating…" : "Update password"}
          </button>
        </div>
      </form>

      {/* ── Recovery email ─────────────────────────────────────────────────── */}
      <form className="settings-form" onSubmit={handleSaveEmail} style={{ marginBottom: 0 }}>
        <div className="settings-form-group">
          <label>Recovery Email</label>
          <p style={{ color: "#64748b", fontSize: 13, marginBottom: 8 }}>
            Used to recover your account if you lose access.
            Must be different from your login email.
          </p>
          <input
            type="email"
            value={recoveryEmail}
            onChange={(e) => setRecoveryEmail(e.target.value)}
            placeholder="recovery@example.com"
            autoComplete="off"
          />
        </div>
        <div style={{ display: "flex", gap: 10, marginBottom: 24 }}>
          <button className="btn-save" type="submit" disabled={loading}>
            {loading ? "Saving…" : "Save"}
          </button>
          {recoveryEmail !== originalEmail && (
            <button
              type="button"
              className="btn-cancel"
              onClick={() => { setRecoveryEmail(originalEmail); setMessage(null); }}
            >
              Cancel
            </button>
          )}
        </div>
      </form>

      <div className="settings-form">

        {/* ── Online visibility ───────────────────────────────────────────── */}
        <div
          className="settings-form-group"
          style={{
            display: "flex", alignItems: "center",
            justifyContent: "space-between",
            padding: "14px 0",
            borderTop: "1px solid var(--color-border-tertiary, #e2e8f0)",
          }}
        >
          <div>
            <label style={{ fontWeight: 500, marginBottom: 2, display: "block" }}>
              Show Online Status
            </label>
            <p style={{ color: "#64748b", fontSize: 13, margin: 0 }}>
              {showOnline
                ? "Other users can see when you are online"
                : "Your online status is hidden from other users"}
            </p>
          </div>

          {/* Toggle switch */}
          <label className="switch" style={{ flexShrink: 0, marginLeft: 16 }}>
            <input
              type="checkbox"
              checked={showOnline}
              onChange={(e) => handleToggleOnline(e.target.checked)}
            />
            <span className="slider" />
          </label>
        </div>

        {/* ── Media download mode ─────────────────────────────────────────── */}
        <div
          className="settings-form-group"
          style={{
            padding: "14px 0",
            borderTop: "1px solid var(--color-border-tertiary, #e2e8f0)",
          }}
        >
          <label style={{ fontWeight: 500, display: "block", marginBottom: 4 }}>
            Media Auto-Download
          </label>
          <p style={{ color: "#64748b", fontSize: 13, marginBottom: 12 }}>
            Choose whether images, videos and files download automatically in chat.
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

            {/* Manual (default) */}
            <label
              style={{
                display: "flex", alignItems: "flex-start", gap: 12,
                cursor: "pointer", padding: "10px 14px",
                border: `2px solid ${downloadMode === "manual" ? "#1e40af" : "#e2e8f0"}`,
                borderRadius: 10,
                background: downloadMode === "manual" ? "#eff6ff" : "transparent",
                transition: "border .15s, background .15s",
              }}
            >
              <input
                type="radio"
                name="downloadMode"
                value="manual"
                checked={downloadMode === "manual"}
                onChange={() => handleDownloadMode("manual")}
                style={{ marginTop: 2 }}
              />
              <div>
                <div style={{ fontWeight: 500 }}>Manual (recommended)</div>
                <div style={{ fontSize: 12, color: "#64748b" }}>
                  Media downloads only when you tap it. Saves data and storage.
                </div>
              </div>
            </label>

            {/* Auto */}
            <label
              style={{
                display: "flex", alignItems: "flex-start", gap: 12,
                cursor: "pointer", padding: "10px 14px",
                border: `2px solid ${downloadMode === "auto" ? "#1e40af" : "#e2e8f0"}`,
                borderRadius: 10,
                background: downloadMode === "auto" ? "#eff6ff" : "transparent",
                transition: "border .15s, background .15s",
              }}
            >
              <input
                type="radio"
                name="downloadMode"
                value="auto"
                checked={downloadMode === "auto"}
                onChange={() => handleDownloadMode("auto")}
                style={{ marginTop: 2 }}
              />
              <div>
                <div style={{ fontWeight: 500 }}>Auto-download</div>
                <div style={{ fontSize: 12, color: "#64748b" }}>
                  Images, videos and files download automatically as they arrive.
                </div>
              </div>
            </label>

          </div>
        </div>
      </div>
    </div>
  );
}


export default SettingsPage;
